<template>
  <div>
    <div class="row">
      <div class="col-sm-12">
        <h1 class="page-title pull-left">Enter Site Information</h1>
        <div class="pull-right">
          <button class="pointer btn btn-lg btn-primary" v-on:click="createNew">
            Create New
          </button>
        </div>
      </div>
    </div>

    <div class="panel">
      <search-fields :form="form" :fields="searchFieldsList"></search-fields>

      <loading :working="form.working()"></loading>

      <div class="panel-body" v-if="!form.working()">
        <div class="col-xs-12 table-responsive">
          <table class="table table-striped">
            <thead>
              <tr>
                <th>Name</th>
                <th>Contract</th>
                <th>Municipality</th>
                <th>Address</th>
                <th>Zone</th>
                <th>Trap Schedule</th>
                <th>Larval Schedule</th>
                <th>Adulticide Schedule</th>
                <th width="120"></th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item, i) in form.list" :key="i">
                <td>{{ item.attributes.name }}</td>
                <td>{{ contractName(item.attributes.contractId) }}</td>
                <td>{{ municipalityName(item.attributes.municipalityId) }}</td>
                <td
                  class="pointer"
                  v-on:click="
                    showMap(
                      `${item.attributes.address}, ${
                        item.attributes.city
                      } ${stateName(item.attributes.stateId)} ${
                        item.attributes.zip
                      } `
                    )
                  "
                >
                  <i class="fa fa-map"></i>
                  {{ item.attributes.address }}<br />
                  {{ item.attributes.city }},
                  {{ stateName(item.attributes.stateId) }}
                  {{ item.attributes.zip }}
                </td>
                <td>{{ zoneName(item.attributes.zoneId) }}</td>
                <td>
                  Starts:
                  <span v-if="item.attributes.trapScheduleStart">{{
                    item.attributes.trapScheduleStart | date
                  }}</span
                  ><br />
                  every {{ item.attributes.trapScheduleFrequency }} days
                </td>
                <td>
                  Starts:
                  <span v-if="item.attributes.larvalScheduleStart">{{
                    item.attributes.larvalScheduleStart | date
                  }}</span
                  ><br />
                  every {{ item.attributes.larvalScheduleFrequency }} days
                </td>
                <td>
                  Starts:
                  <span v-if="item.attributes.adulticideScheduleStart">{{
                    item.attributes.adulticideScheduleStart | date
                  }}</span
                  ><br />
                  every {{ item.attributes.adulticideScheduleFrequency }} days
                </td>

                <td>
                  <!--<a class="pointer text-primary" v-on:click="form.showEdit({id: item.id})"><i class="fa fa-pencil" style="margin-right: 10px;"></i></a>-->
                  <router-link
                    :to="{ name: 'data-site-details', params: { id: item.id } }"
                    title="Details"
                    ><i class="fa fa-ellipsis-h" style="margin-right: 10px;"></i
                  ></router-link>
                  <a
                    class="pointer text-danger"
                    v-on:click="form.destroy(item.id)"
                    title="Delete"
                    ><i class="fa fa-times"></i
                  ></a>
                </td>
              </tr>
            </tbody>
            <pager :form="form"></pager>
          </table>
        </div>
      </div>
    </div>

    <site-form :form="form"></site-form>
    <google-map ref="gmap"></google-map>
  </div>
</template>

<script>
import SitesService from '@/services/SitesService';
import Form from '@/utils/form';
import loader from '@/utils/loader';
import siteForm from '@/components/forms/site_details';
import pager from '@/components/forms/pager';
import googleMap from '@/components/googleMap';
import searchFields from '@/components/search_fields';
import loading from '@/components/loading';

import store from '@/store';

export default {
  name: 'sites',

  props: ['id'],

  components: {
    pager,
    siteForm,
    googleMap,
    searchFields,
    loading,
  },

  data() {
    return {
      searchFieldsList: { site: 'Site', address: 'Address', zone: 'Zone' },
      form: new Form(SitesService, {
        isActive: null,
        address: null,
        city: null,
        stateId: null,
        zip: null,
        contactPerson: null,
        contactDate: null,
        phoneNumber: null,
        foundDate: null,
        foundBy: null,
        scheduleStart: null,
        scheduleFrequency: null,
        coordinates: [],
        geojson: '{}',
      }),
    };
  },

  methods: {
    stateName(id) {
      return this.$store.getters.stateNameById(id);
    },
    zoneName(id) {
      return this.$store.getters.zoneNameById(id);
    },
    contractName(id) {
      return this.$store.getters.contractNameById(id);
    },
    municipalityName(id) {
      return this.$store.getters.municipalityNameById(id);
    },
    showMap(coordinates) {
      this.$refs.gmap.showMap(coordinates);
    },
    createNew() {
      this.$store.commit('setSelectedMappable', null);
      this.$store.commit('resetGeoJSON');
      this.form.showEdit({ title: 'Add New Site' });
      this.form.data.coordinates = [{ lat: null, lon: null }];
    },
  },

  created() {
    window.bus.$on('item-created', (id) => {
      if (this.$route.path.indexOf('sites') > -1) {
        this.$router.push({ name: 'data-site-details', params: { id: id } });
      }
    });
  },

  mounted() {
    loader.lookups().then(() => {
      this.form.getList();
    });

    if (this.$props.id == 'new') {
      this.$store.commit('setSelectedMappable', null);
      this.$store.commit('resetGeoJSON');

      setTimeout(() => {
        // delay so that the modal form will actually scroll, and not be cut off
        this.form.showEdit({ title: 'Add New Site' });
      }, 1500);
    }
  },
};
</script>

<style lang="scss"></style>
